<template>
    <share-entity-dialog ref="base" collection="blocks" :title="$t('common.share_block')"
        :shared-toast="$t('common.block_shared')" />
</template>

<script>
import ShareEntityDialog from "./ShareEntityDialog";

export default {
    name: "ShareBlockDialog",
    components: { ShareEntityDialog },
    methods: {
        show(entity) {
            this.$refs.base.show(entity)
        },
    }
}
</script>
